import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
const CustomPasswordField = ({
  id,
  label,
  name,
  autoComplete,
  autoFocus,
  endAdornmentIcon: EndAdornmentIcon,
  formik,
  placeholder,
  loginPage = false,
  ...props
}) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleChange = (e) => {
    const inputValue = e.target.value;
    const hasLeadingSpace = /^\s/.test(inputValue);
    if (!hasLeadingSpace) {
      formik?.handleChange(e);
    }
  };
  return (
    <TextField
      variant="outlined"
      margin="normal"
      required
      fullWidth
      type={showPassword ? "text" : "password"}
      id={id}
      label={label}
      name={name}
      autoComplete={autoComplete}
      autoFocus={autoFocus}
      placeholder={placeholder}
      value={formik?.values[name]}
      onChange={handleChange}
      onBlur={formik?.handleBlur}
      error={formik?.touched[name] && Boolean(formik?.errors[name])}
      helperText={
        formik?.touched[name] && formik?.errors[name] ? formik.errors[name] : ""
      }
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            {EndAdornmentIcon && (
              <EndAdornmentIcon style={{ fontSize: "18px" }} />
            )}
          </InputAdornment>
        ),
        style: {
          fontWeight: 300,
          height: "40px",
           fontFamily: 'Urbane-Light'
        },
        inputProps: {
          style: {
            padding: "8px 14px",
            fontSize: "12px",
          },
        },

        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {showPassword ? (
                <VisibilityOff />
              ) : (
                <Visibility style={{ fontSize: "20px" }} />
              )}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default CustomPasswordField;
